import {BaseDataBuilder, IBaseData, ArrayDefaultValue} from './BaseDataBuilder'
import {DATA} from '@wix/component-protocol/schema' // eslint-disable-line wix-editor/no-internal-import
import {pick} from 'lodash'
import type {Builder} from '@wix/document-services-types'

export class ArrayBuilder extends BaseDataBuilder {
    private readonly availableDataInnerProps = [
        'dataType',
        DATA.DATA_TYPE.text,
        DATA.DATA_TYPE.number,
        DATA.DATA_TYPE.booleanValue,
        DATA.DATA_TYPE.link,
        DATA.DATA_TYPE.image,
        DATA.DATA_TYPE.localDateTime
    ] as const

    constructor(displayName: string, defaultValue: ArrayDefaultValue, private innerData: IBaseData) {
        super('array', displayName, defaultValue)
    }

    toBuilderDataItem(): Builder.DataItem {
        const fullDataItem = this.innerData.toBuilderDataItem()
        const innerDataItem = pick(fullDataItem, this.availableDataInnerProps)
        return {
            displayName: this.displayName,
            dataType: DATA.DATA_TYPE.arrayItems,
            defaultValue: this.defaultValue,
            [DATA.DATA_TYPE.arrayItems]: {
                dataItem: innerDataItem
            }
        }
    }
}
